<template>
    <div class="chart-container">
        <Chart
            v-if="hasData"
            type="bar"
            :data="chartData"
            :options="chartOptions"
            class="w-full h-full"
        />
        <div v-else class="chart-empty">Sem dados</div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import SafeChart from '@/components/SafeChart.vue';

const Chart = SafeChart;

const props = defineProps({
    rawData: { type: Object, default: () => ({}) }
});

const hasData = computed(() => {
    return props.rawData?.labels?.length > 0 && props.rawData?.datasets?.length > 0;
});

const chartData = computed(() => {
    if (!hasData.value) return {};
    
    const datasets = props.rawData.datasets.map(ds => {
        // Specific colors for "Contratos Atuais"
        return {
            ...ds,
            // Assuming labels match the mockup: Leads, Provedor e Assinatura, Cotação
            backgroundColor: ds.backgroundColor || ['#3b82f6', '#10b981', '#f59e0b'],
            hoverBackgroundColor: ds.backgroundColor || ['#60a5fa', '#34d399', '#fbbf24'],
            borderColor: 'transparent',
            borderRadius: 6,
            barPercentage: 0.5,
            categoryPercentage: 0.8,
        };
    });

    return {
        ...props.rawData,
        datasets
    };
});

const chartOptions = computed(() => {
    return {
        indexAxis: 'y', // Makes it horizontal
        responsive: true,
        maintainAspectRatio: false,
        animation: { duration: 500, easing: 'easeOutQuart' },
        interaction: {
            mode: 'index',
            intersect: false,
        },
        plugins: {
            legend: { display: false },
            tooltip: {
                backgroundColor: 'rgba(20, 20, 20, 0.85)',
                titleColor: '#ffffff',
                bodyColor: '#d1d5db',
                borderColor: 'rgba(255, 255, 255, 0.1)',
                borderWidth: 1,
                cornerRadius: 8,
                padding: 12,
            }
        },
        scales: {
            x: {
                grid: { color: 'rgba(255, 255, 255, 0.05)', drawBorder: false },
                ticks: { color: '#6b7280', font: { size: 11, family: 'Inter, sans-serif' } },
                border: { display: false },
                beginAtZero: true
            },
            y: {
                grid: { display: false, drawBorder: false },
                ticks: { color: '#e5e7eb', font: { size: 12, family: 'Inter, sans-serif' } },
                border: { display: false }
            }
        }
    };
});
</script>

<style scoped>
.chart-container {
    height: 220px;
    width: 100%;
    position: relative;
}
.chart-empty {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6b7280;
    font-size: 0.9rem;
}
</style>
